import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import LoadingGrid from "../GridView/LoadingGrid";

export default function BubbleLoading(props) {
  return (
    <div style={{ background: "white" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${7 + 2}, auto)`,
          gridTemplateRows: 1,
          overflow: "auto",
          height: 120,
          paddingRight: 10,
          paddingLeft: 10,
          width: "100%",
          height: "100%",
          paddingTop: 35,
        }}
        className="disable-scroll-bar w-100"
      >
        {[...Array(10).keys()].map((item) => (
          <div
            style={{
              minWidth: "max-content",
              marginRight: 8,
              marginLeft: 8,
              justifySelf: "center",
              userSelect: "none",
            }}
          ></div>
        ))}
      </div>
      <div>
        <Skeleton
          variant="rect"
          className="mx-auto"
          style={{
            height: 50,
            width: "94%",
            borderRadius: 5,
            marginTop: 40,
            marginBottom: 10,
            transform: "scale(0.984)",
            backgroundColor: "#c3c3c3",
          }}
        />
      </div>
      <LoadingGrid cellHeight={240} settings={props.settings} />
    </div>
  );
}
